import { DateTime } from 'luxon';

// Table of tokens: https://moment.github.io/luxon/#/formatting?id=table-of-tokens
function formatDateTime<T extends string | DateTime | null>(
  dateTime: T,
  format?: string,
): T extends null ? null : string;
function formatDateTime(
  dateTime: string | DateTime | null,
  format: string = 'M/d/yy',
) {
  if (dateTime === null) {
    return null;
  }

  if (typeof dateTime === 'string') {
    dateTime = DateTime.fromISO(dateTime);
  }

  if (!DateTime.isDateTime(dateTime)) {
    throw new Error('Invalid argument provided to formatDateTime().');
  }

  return dateTime.toFormat(format, { locale: 'en' });
}

export default formatDateTime;
